import TextButton from 'LuxKit/Button/TextButton'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { useWishlistIndex } from 'wishlists/hooks'
import config from 'constants/config'
import { CHAT_TRIP_PLANNER_ROUTE } from 'tripPlanner/pages/chat/ChatTripPlannerPage/hooks/useChatNavigation'
import { useIsMobileOrTablet } from 'hooks/useIsMobileOrTablet'

const MenuItem = styled.div`
  position: relative;
`

type InheritedTextButtonProps = Pick<ComponentProps<typeof TextButton>, 'size'>

interface Props extends InheritedTextButtonProps {}

function NavigationHeaderTripsMenu(props: Props) {
  if (!config.ENABLE_TRIP_PLANNER) return null

  return <NavigationHeaderTripsMenuInner {...props} />
}

function NavigationHeaderTripsMenuInner(props: Props) {
  const isLoggedIn = useAppSelector(selectLoggedIn)

  if (!isLoggedIn) return <AITripPlannerMenuItem {...props} />

  return <WishlistMenuItem {...props} />
}

function AITripPlannerMenuItem(props: Props) {
  const { size } = props
  const intl = useIntl()
  const isMobileOrTablet = useIsMobileOrTablet()
  const tripPlannerUrl = isMobileOrTablet ? '/trip-planner' : CHAT_TRIP_PLANNER_ROUTE

  const aiTripPlannerText = intl.formatMessage({
    id: 'EYQsWpC_SwW6ZS0Xb0Yz',
    defaultMessage: 'AI TripPlanner',
    description: 'Branding label for the AI TripPlanner feature in the header',
  })

  return (
    <MenuItem>
      <TextButton
        kind="tertiary"
        variant="dark"
        size={size}
        startIcon={<SolidSparklesIcon />}
        to={tripPlannerUrl}
      >
        {aiTripPlannerText}
      </TextButton>
    </MenuItem>
  )
}

function WishlistMenuItem(props: Props) {
  const { size } = props
  const intl = useIntl()
  const { data: wishlistData } = useWishlistIndex()

  const hasSavedItems = Boolean(
    wishlistData?.wishlists.find((wishlist) => wishlist.isDefault)?.itemCount,
  )

  const wishlistText = intl.formatMessage({
    id: '8tn_OvJmXrdKVNnw4EQO',
    defaultMessage: 'Wishlist',
    description: 'Wishlist navigation button text in the website header',
  })

  return (
    <MenuItem>
      <TextButton
        kind="tertiary"
        variant="dark"
        size={size}
        startIcon={hasSavedItems ? <SolidHeartIcon colour="favourite" /> : <LineHeartIcon />}
        to="/wishlists"
      >
        {wishlistText}
      </TextButton>
    </MenuItem>
  )
}

export default NavigationHeaderTripsMenu
